/* [RD-ROW-TAG 2026-10-01, user] The ROW badge of the Refunds and Disputes tables' Tag column — the same look as
   the Payments table's ROW tag (PaymentsPage RowStatusTag), so a Team ROW refund or dispute reads the same as a Team
   ROW payment. The server stores the tag (services/caseRowTag.ts): the payment has the ROW tag, or the Sales/PM Name
   is on Team ROW that month.
   [TAG-STYLE 2026-11-03, user] Now the Payments tags' "Clean label" (components/TagLabel): "ROW" in violet capitals on a
   violet-tinted glass label, no dot. */
import React from 'react';
import { TagBadge } from './TagLabel';

export const CASE_ROW_TAG_TITLE = 'Team ROW: its payment has the ROW tag, or the Sales/PM Name is on Team ROW';

export const RowTagBadge: React.FC<{ title?: string }> = ({ title = CASE_ROW_TAG_TITLE }) => (
  <TagBadge kind="row" label="ROW" title={title} />
);
